import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { fetchConsent } from "../lib/consent";

/* Settings → "Privacy & consent": status, legal links, withdraw (= existing account deletion flow). */
export const ConsentCard = () => {
  const [c, setC] = useState(null);
  useEffect(() => { fetchConsent().then(setC).catch(() => setC(null)); }, []);
  const when = c?.consented_at ? new Date(c.consented_at).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : null;
  return (
    <section className="card fade-up" data-testid="consent-card">
      <p className="eyebrow">Privacy &amp; consent</p>
      <p className="font-bold mt-1 flex items-center gap-2"><ShieldCheck size={16} className="text-primary" /> Your consent</p>
      <p className="text-sm text-muted mt-1" data-testid="consent-status">{when ? <>Consent given on <span className="notranslate" translate="no">{when}</span> (version <span className="notranslate" translate="no">{c.version}</span>).</> : c ? "No consent on record yet." : "Consent status unavailable offline."}</p>
      <p className="text-xs text-muted mt-2"><Link to="/terms" className="underline underline-offset-4" data-testid="consent-card-terms">Terms of Service</Link> · <Link to="/privacy" className="underline underline-offset-4" data-testid="consent-card-privacy">Privacy Policy</Link></p>
      <button type="button" className="btn-secondary text-[#FF7A7A] mt-4" onClick={() => document.querySelector("[data-testid=delete-account-button]")?.click()} data-testid="withdraw-consent-button">Withdraw consent &amp; delete account</button>
    </section>
  );
};
